import React from "react";
import {TUserInfoTypes} from "@/types/redux_type";
import {TExamPlanItem} from "@/page-components/detail/Intro/exam_plan";
import {TExamDetailFixedDataType} from "@/types/index";
import {VerifyEnum} from "@/types/verify";

export const DetailContext = React.createContext<{
  userInfo: TUserInfoTypes
  cert_id: string
  signupInfo: TExamPlanItem[]
  data: TExamDetailFixedDataType;
  isHistoryPass: boolean;
  isAddExtraHeight?: boolean;
  addPassResultLoading?: boolean;
}>({
  isAddExtraHeight: false,
  isHistoryPass: false,
  data: {
    leftNavs: [],
    cert_id: process.env.NEXT_PUBLIC_FCRA_CERTID as string,
    isProfession: false,
    type: 'fcra',
    typeEnum: VerifyEnum.FCRA,
    exam_info: {
      pass_tips: "",
      pass_link: '',
      no_pass_tips: '',
      signup_text: [''],
      leida_url: "",
      require: '',
      duration: '',
      method: '',
      exam_money: 0,
      pass_condition: '',
    },
    short_cn_title: '',
    document: [{
      label: '',
      href: ''
    }],
    ability_demanded: {
      suit_people: '',
      reward: '',
      url: '',
      text: [],
    },
    qa: [{
      id: 0,
      question: '',
      answer: ''
    }],
    title: '',
    certificate_title: "",
    short_english_title: '',
    english_title: '',
    intro: '',
  },
  signupInfo: [],
  cert_id: '',
  userInfo: {
    init: false,
    isTeacher: false,
    isPassRealnameAuthentication: false, // 是否通过初级实名认证
    isPassStudentAuthentication: false, // 是否通过学生认证
    isOrganizationAdmin: false, // 是否是组织管理员
    isSupplierState: false, // 是否是供应商
  }
})
